import { InfoOutlined } from '@mui/icons-material';
import { TextField, TextFieldProps, Tooltip, InputAdornment } from '@mui/material';
import React from 'react';

export type TextFieldWithTooltipProps = TextFieldProps & {
  tooltip?: string;
};
type InputSlot = { endAdornment?: React.ReactNode };

export default function TextFieldWithTooltip({ tooltip, InputProps: legacyInputProps, slotProps: externalSlotProps, ...props }: TextFieldWithTooltipProps) {
  const inputSlot = externalSlotProps?.input as InputSlot | undefined;
  const existingEndAdornment = inputSlot?.endAdornment ?? legacyInputProps?.endAdornment;

  return (
    <TextField
      {...props}
      slotProps={{
        ...externalSlotProps,
        input: {
          ...legacyInputProps,
          ...inputSlot,
          endAdornment: (
            <>
              {tooltip && (
                <InputAdornment position="end">
                  <Tooltip title={tooltip}>
                    <InfoOutlined fontSize="small" />
                  </Tooltip>
                </InputAdornment>
              )}
              {existingEndAdornment}
            </>
          ),
        },
      }}
    />
  );
}
